import React from 'react';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import FacetPlanAddExpense from 'Views/Page/Content/Modal/Layouts/FacetPlanAddExpense';

const AddFacetPlanExpense = () => {
  const { clearModalCollection } = useModalContext();

  const onSubmit = async () => {
    clearModalCollection();
  };

  return (
    <FacetPlanAddExpense onSubmit={onSubmit} />
  );
};

AddFacetPlanExpense.defaultProps = {
};

AddFacetPlanExpense.propTypes = {
};

export default AddFacetPlanExpense;
